module.exports = __webpack_public_path__ + "img/ck.a6ea078c.png";